import { useTranslate } from '@festina-life/ui/hooks'

import { GlMapExcelUploadForm } from '../../components/createGlMapDraft/GlMapExcelUploadForm'
import { GlMapJsonUploadForm } from '../../components/createGlMapDraft/GlMapJsonUploadForm'
import { UploadVersionButton } from '../../components/uploadVersionButton/UploadVersionButton'
import { useMappingId } from '../../system/useMappingId'

/**
 * Adds a new version to the GL map in scope by uploading either another GL-map Excel
 * document, or the in-out entity of a version as JSON.
 */
export const GlMapUploadVersionButton = () => {
  const translate = useTranslate()
  const mappingId = useMappingId()

  return (
    <UploadVersionButton
      itemId={mappingId}
      type="glMap"
      formatsConfiguration={[
        {
          label: translate('documentFormat.excel'),
          renderForm: (formProps) => (
            <GlMapExcelUploadForm
              {...formProps}
              expectedMappingName={mappingId}
            />
          ),
        },
        {
          label: translate('documentFormat.json'),
          renderForm: (formProps) => (
            <GlMapJsonUploadForm
              {...formProps}
              expectedEntityName={mappingId}
            />
          ),
        },
      ]}
    />
  )
}
